import { Box, Button, Card, Container, Flex, Group, ScrollArea, Table, TextInput } from "@mantine/core";
import QueryString from "qs";
import useSWR from "swr";
import dayjs from "dayjs";
import { parsePhone } from "@/utils/helpers";
import CardHeader from "@/components/CardHeader";
import { useSearchParams } from "react-router-dom";
import useAuthStore from "@/store/useAuthStore";
import RoutePagination from "@/components/RoutePagination";
import DetailModal from "./DetailModal";
import { useState } from "react";
import { useForm } from "@mantine/form";
import ExcelUploadModal from "./ExcelUploadModal";
import TableEmpty from "@/components/placeholders/TableEmpty";

export default function Partners() {
  const [searchParams, setSearchParams] = useSearchParams();
  const pageSize = useAuthStore((state) => state.pageSize);
  const user = useAuthStore((state) => state.user);
  const page = searchParams.get("page") || 1;

  const form = useForm({
    initialValues: {
      name: "",
    },
  });

  const [sort, setSort] = useState("createdAt:desc");
  const [filters, setFilters] = useState({});

  const params = QueryString.stringify({
    filters: {
      company: user?.company?.id,
      ...filters,
    },
    populate: "*",
    sort: [sort],
    pagination: {
      page,
      pageSize,
    },
  });

  const title = "거래처";
  const { data, mutate, isLoading } = useSWR(["/partners", params]);
  console.log("🚀 ", data?.data);

  function handleSearch() {
    setSearchParams({ page: 1 });
    let newFilter = {};

    // EDIT FILTERS
    const { name } = form.values;
    if (name) newFilter = { ...newFilter, name: { $contains: name } };

    setFilters(newFilter);
  }

  function handleClearSearch() {
    setSearchParams({ page: 1 });
    form.reset();
    setFilters({});
  }

  return (
    <Container fluid>
      <Card>
        <CardHeader
          title={`${title} 관리`}
          action={
            <Flex gap="xs">
              <ExcelUploadModal mutate={mutate} />
              <DetailModal mutate={mutate} item={null} id={null} title={title} />
            </Flex>
          }
        />

        <Card.Section withBorder>
          <form onSubmit={form.onSubmit(handleSearch)}>
            <Box my="sm" mx="md">
              <Group position="left">
                <TextInput mb={0} placeholder="이름" {...form.getInputProps("name")} />

                <Button variant="outline" onClick={handleClearSearch}>
                  초기화
                </Button>
                <Button type="submit">검색</Button>
              </Group>
            </Box>
          </form>
        </Card.Section>

        <Card.Section>
          <ScrollArea>
            <Table>
              <thead>
                <tr>
                  <th>#</th>
                  <th className="tc">거래처명</th>
                  <th className="tl">주소</th>
                  <th className="tl">세부주소</th>
                  <th className="tc">담당자명</th>
                  <th className="tc">담당자 전화번호</th>
                  <th className="tc">등록일</th>
                  <th className="tc">관리</th>
                </tr>
              </thead>
              <tbody>
                {!isLoading && data?.data?.length === 0 && (
                  <TableEmpty title="등록된 거래처가 없습니다." text="거래처 등록을 통해 거래처를 추가해주세요." />
                )}
                {data?.data?.map((row, idx) => {
                  const item = row.attributes || {};
                  return (
                    <tr key={row.id}>
                      <td>{idx + (page - 1) * pageSize + 1}</td>
                      <td className="tc">{item.name}</td>
                      <td className="tl">{item.address}</td>
                      <td className="tl">{item.addressDetail || "-"}</td>
                      <td className="tc">{item.managerName}</td>
                      <td className="tc">{parsePhone(item.managerPhoneNumber)}</td>
                      <td className="tc">{dayjs(item.createdAt).format("YYYY-MM-DD")}</td>
                      <td className="tc">
                        <DetailModal item={item} mutate={mutate} id={row.id} title={title} />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </ScrollArea>
        </Card.Section>

        <RoutePagination total={data?.meta?.pagination?.pageCount} page={page} setSearchParams={setSearchParams} />
      </Card>
    </Container>
  );
}
